import ApprovedArrow from 'assets/icons/Arrows/Arrow1.svg';
import styled, { css } from "styled-components";

export const TableTitle = styled.div`
font-weight: bold;
font-size: 18.5px;
line-height: 28px;
color: #002E5C;
span{
font-weight: 400;
font-size: 12px;
line-height: 17px;
color: #B5B5C3;
padding-left: 11px;
}
`
export const Status = styled.div`
padding-left: 9.08px;
padding-top: 5.58px;
padding-bottom: 5.58px;
padding-right: 8.5px;
border-radius: 5px;
font-size: 13px;
font-weight: 600;
line-height: 20px;
width: fit-content;
${(props) => (props.type === 'paid' ?
    css`
        color: #2555EF;
        background: rgba(37, 85, 239, 0.2);

      `
    : css`
        color: #FA3372;
        background: rgba(250, 51, 114, 0.2);
              `
  )}
            `
export const CustomSelect = styled.div`
width: 134.83px;
position: relative;

`
export const Select = styled.select`
border-radius: 7px;
width: 134.83px;
height: 30px;
gap: 20px;
padding-left: 10px;
font-weight: bold;
font-size: 13px;
-moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  color : ${(props) => (props.typeStutus === 'Approved' ? '#002E5C' : props.typeStutus === 'Pending' ? '#FA3372' : '#FBA12C')};
  padding-left: ${(props) => (props.typeStutus === 'Approved' && '30px')}; 
`
export const Img = styled.img`
position: absolute;
right: 10px;
top: 40%;
`

export const FilterWrapper = styled.div`
width: 100%;
height: 241px;
padding-top: 25.17px;
padding-bottom: 27px;
padding-left: 31px;
padding-right: 31px;
margin-top: 15px;
`
export const ButtonWrapper = styled.div`
display: flex;
height: 44px;
margin-top: 27px;
margin-left:30px;

`
export const AccountWrapper = styled.div`
display: flex;
flex-direction: column;
`
export const Account = styled.button`
  font-size: 11px;
  line-height: 21px;
  text-transform: capitalize;
  color: #2455ef;
  font-weight: bold;
  background: transparent;
  border: none;
  text-align: left;
  &:hover {
    text-decoration-line: underline;
    cursor: pointer;
  }
`

export const Label = styled.label`
  color: #002E5C;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
`

export const DatePickerWrapper = styled.div`
    position: relative;

  & .react-datepicker-wrapper {
    width: 100%;
  
  }

div{
  div.react-datepicker__input-container input{
    width: 100%;
    /* border: none; */
    background-color: rgb(246, 246, 246);
    border-radius: 5px;
    color: #3f4254;
    padding-inline: 10px;
  }
}
`
export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;